var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Vue from 'vue';
import 'vue-router';
import 'vuex';
import Auth from '@/common/auth';
import { connectCommbookRealtime } from './realtime';
import LocationPanel from './components/location-panel.vue';
import ConversationList from './components/conversation-list.vue';
import MessagePanel from './components/message-panel.vue';
import CreateConversation from './components/create-conversation.vue';
import { getNavigation, getConversations, getConversation, markConversationRead, markAllConversationsRead, setConversationStar } from './api';
import { isUnread } from './utils';
export default Vue.extend({
    name: 'GlobalCommbook',
    components: { LocationPanel: LocationPanel, ConversationList: ConversationList, MessagePanel: MessagePanel, CreateConversation: CreateConversation },
    data: function () {
        return {
            locations: [],
            locationId: '',
            classId: '',
            starred: false,
            starredUnreadCount: 0,
            createOpen: false,
            collapsed: false,
            readFilter: 'UNREAD',
            records: [],
            current: 1,
            size: 20,
            total: 0,
            selectedId: '',
            detail: null,
            selectedRecord: null,
            selectedRecordIndex: 0,
            optimisticReads: {},
            locationsLoading: false,
            listLoading: false,
            loadingMore: false,
            detailLoading: false,
            locationsError: '',
            listError: '',
            loadMoreError: '',
            detailError: '',
            actionError: '',
            failedReadId: '',
            bulkReading: false,
            readBusy: {},
            starBusy: {},
            locationsRequest: 0,
            listRequest: 0,
            detailRequest: 0,
            destroyed: false,
            refreshing: false,
            initialLoadStarted: false,
            initialLoading: true,
            initialTimer: null,
            pollTimer: null,
            refreshTimer: null,
            refreshPending: false,
            restoringRoute: false,
            stopRealtime: null
        };
    },
    computed: {
        actorId: function () {
            return String(Auth.getUserId() || '');
        },
        canAccess: function () {
            var permissions = this.$store.state.user.rolePermission;
            return Array.isArray(permissions) && permissions.includes('Global Commbook');
        },
        canReply: function () {
            var permissions = this.$store.state.user.rolePermission;
            return (this.canAccess &&
                Array.isArray(permissions) &&
                (permissions.includes('GlobalCommbookMessages_Full') ||
                    permissions.includes('GlobalCommbookMessages_Edit')));
        },
        canCreate: function () {
            var permissions = this.$store.state.user.rolePermission;
            return (this.canAccess &&
                Array.isArray(permissions) &&
                (permissions.includes('GlobalCommbookMessages_Full') ||
                    permissions.includes('GlobalCommbookMessages_Edit') ||
                    permissions.includes('GlobalCommbookMessages_Create')));
        },
        canDelete: function () {
            var permissions = this.$store.state.user.rolePermission;
            return (this.canAccess &&
                Array.isArray(permissions) &&
                permissions.includes('GlobalCommbookMessages_Full'));
        },
        mutating: function () {
            return (this.bulkReading ||
                Object.values(this.readBusy).some(Boolean) ||
                Object.values(this.starBusy).some(Boolean));
        },
        refreshBlocked: function () {
            return (this.initialLoading ||
                this.refreshing ||
                this.mutating ||
                this.locationsLoading ||
                this.listLoading ||
                this.loadingMore ||
                this.detailLoading ||
                this.restoringRoute);
        },
        hasMore: function () {
            return this.current * this.size < this.total;
        },
        visibleRecords: function () {
            var _this = this;
            var records = this.records
                .map(function (record) { return _this.presentConversation(record); })
                .filter(function (record) {
                return _this.readFilter !== 'UNREAD' ||
                    String(record.id) === _this.selectedId ||
                    isUnread(record);
            });
            if (!this.selectedId || records.some(function (record) { return String(record.id) === _this.selectedId; }))
                return records;
            if (this.readFilter === 'UNREAD' && this.selectedRecord) {
                records.splice(Math.min(this.selectedRecordIndex, records.length), 0, this.presentConversation(this.selectedRecord));
            }
            else if (this.readFilter === 'ALL' && this.detail) {
                records.unshift(this.presentConversation(this.detail));
            }
            return records;
        },
        listScopeKey: function () {
            return [this.starred, this.locationId, this.classId, this.readFilter].join('|');
        }
    },
    mounted: function () {
        var _this = this;
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        if (!this.canAccess)
            return;
        this.pollTimer = window.setInterval(function () { return _this.requestRefresh('poll'); }, 60000);
        this.initialTimer = window.setTimeout(function () { return _this.initialize(); }, 1000);
        this.stopRealtime = connectCommbookRealtime(this.onRealtimeEvent);
    },
    beforeDestroy: function () {
        this.destroyed = true;
        this.locationsRequest++;
        this.listRequest++;
        this.detailRequest++;
        if (this.initialTimer !== null)
            window.clearTimeout(this.initialTimer);
        if (this.pollTimer !== null)
            window.clearInterval(this.pollTimer);
        if (this.refreshTimer !== null)
            window.clearTimeout(this.refreshTimer);
        if (this.stopRealtime)
            this.stopRealtime();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    },
    methods: {
        initialize: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.initialLoadStarted || this.destroyed || !this.canAccess)
                                return [2 /*return*/];
                            this.initialLoadStarted = true;
                            if (this.initialTimer !== null) {
                                window.clearTimeout(this.initialTimer);
                                this.initialTimer = null;
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, this.restoreInitialSelection()];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            this.initialLoading = false;
                            if (this.refreshPending)
                                this.scheduleRefresh();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        onRealtimeEvent: function (event) {
            if (this.destroyed || !this.canAccess)
                return;
            if (event === 'connected' && !this.initialLoadStarted) {
                this.initialize();
                return;
            }
            this.requestRefresh(event);
        },
        errorMessage: function (error) {
            return error instanceof Error ? error.message : 'Unable to load Commbook. Please try again.';
        },
        routeValue: function (value) {
            return typeof value === 'string' ? value.trim() : '';
        },
        setRouteConversation: function (id, classId) {
            if (this.routeValue(this.$route.query.conversationId) === id &&
                this.routeValue(this.$route.query.classId) === classId)
                return;
            var query = __assign({}, this.$route.query);
            if (id)
                query.conversationId = id;
            else
                delete query.conversationId;
            if (classId)
                query.classId = classId;
            else
                delete query.classId;
            this.$router.replace({ name: 'globalCommbook', query: query }).catch(function (error) {
                if (error && error.name !== 'NavigationCancelled' && error.name !== 'NavigationDuplicated')
                    console.error('Unable to update Commbook URL:', error);
            });
        },
        restoreInitialSelection: function () {
            return __awaiter(this, void 0, void 0, function () {
                var id, detail, locationId_1, classId_1, location_1, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            id = this.routeValue(this.$route.query.conversationId);
                            if (!!id) return [3 /*break*/, 2];
                            if (this.routeValue(this.$route.query.classId))
                                this.setRouteConversation('', '');
                            return [4 /*yield*/, this.loadLocations()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            this.restoringRoute = true;
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, 9, 10, 11]);
                            return [4 /*yield*/, this.loadLocations()];
                        case 4:
                            _a.sent();
                            if (this.destroyed || this.locationsError || !this.restoringRoute)
                                return [2 /*return*/];
                            return [4 /*yield*/, getConversation(id)];
                        case 5:
                            detail = _a.sent();
                            if (this.destroyed || !this.restoringRoute)
                                return [2 /*return*/];
                            locationId_1 = String(detail.schoolId || '');
                            classId_1 = String(detail.classId || this.routeValue(this.$route.query.classId) || '');
                            location_1 = this.locations.find(function (item) { return item.id === locationId_1; });
                            if (!location_1 ||
                                !classId_1 ||
                                !(location_1.classes || []).some(function (item) { return item.id === classId_1; })) {
                                this.setRouteConversation('', '');
                                this.selectScope((this.locations[0] || {}).id || '', '');
                                return [2 /*return*/];
                            }
                            this.locationId = locationId_1;
                            this.classId = classId_1;
                            this.readFilter = 'ALL';
                            this.selectedId = id;
                            this.detail = detail;
                            this.setRouteConversation(id, classId_1);
                            return [4 /*yield*/, this.loadList()];
                        case 6:
                            _a.sent();
                            if (!(!this.destroyed && this.selectedId === id)) return [3 /*break*/, 8];
                            return [4 /*yield*/, this.markRead(detail)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8: return [3 /*break*/, 11];
                        case 9:
                            error_1 = _a.sent();
                            if (this.destroyed || !this.restoringRoute)
                                return [2 /*return*/];
                            this.setRouteConversation('', '');
                            this.selectScope((this.locations[0] || {}).id || '', '');
                            return [3 /*break*/, 11];
                        case 10:
                            this.restoringRoute = false;
                            return [7 /*endfinally*/];
                        case 11: return [2 /*return*/];
                    }
                });
            });
        },
        clearDetail: function (updateRoute) {
            if (updateRoute === void 0) { updateRoute = true; }
            if (this.selectedId && !this.readBusy[this.selectedId])
                this.rollbackOptimisticRead(this.selectedId);
            this.detailRequest++;
            this.selectedId = '';
            this.detail = null;
            this.selectedRecord = null;
            this.selectedRecordIndex = 0;
            this.detailError = '';
            this.detailLoading = false;
            this.failedReadId = '';
            if (updateRoute)
                this.setRouteConversation('', '');
        },
        resetList: function () {
            this.listRequest++;
            this.current = 1;
            this.records = [];
            this.total = 0;
            this.listLoading = false;
            this.loadingMore = false;
            this.listError = '';
            this.loadMoreError = '';
        },
        listQuery: function (current, size) {
            return __assign(__assign(__assign({}, (this.locationId ? { locationId: this.locationId } : {})), (this.classId ? { classId: this.classId } : {})), { starred: this.starred, readFilter: this.readFilter, current: current, size: size });
        },
        loadLocations: function () {
            return __awaiter(this, arguments, void 0, function (background) {
                var request, navigation, selected, error_2;
                var _this = this;
                if (background === void 0) { background = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.canAccess || this.destroyed)
                                return [2 /*return*/, false];
                            request = ++this.locationsRequest;
                            if (!background)
                                this.locationsLoading = true;
                            this.locationsError = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getNavigation()];
                        case 2:
                            navigation = _a.sent();
                            if (this.destroyed || request !== this.locationsRequest)
                                return [2 /*return*/, false];
                            this.locations = navigation.locations;
                            this.starredUnreadCount = Number(navigation.starredUnreadCount) || 0;
                            if (this.restoringRoute)
                                return [2 /*return*/, false];
                            if (this.starred) {
                                if (!this.locations.length)
                                    this.selectScope('', '');
                                return [2 /*return*/, false];
                            }
                            selected = this.locations.find(function (item) { return item.id === _this.locationId; });
                            if (!selected ||
                                (this.classId && !(selected.classes || []).some(function (item) { return item.id === _this.classId; }))) {
                                this.selectScope((selected || this.locations[0] || {}).id || '', '');
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                        case 3:
                            error_2 = _a.sent();
                            if (!this.destroyed && request === this.locationsRequest)
                                this.locationsError = this.errorMessage(error_2);
                            return [2 /*return*/, false];
                        case 4:
                            if (!this.destroyed && request === this.locationsRequest)
                                this.locationsLoading = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        selectScope: function (locationId, classId) {
            this.restoringRoute = false;
            if (!this.starred &&
                this.locationId === locationId &&
                this.classId === classId &&
                this.locationId)
                return;
            this.starred = false;
            this.locationId = locationId;
            this.classId = classId;
            this.resetList();
            this.clearDetail();
            if (locationId)
                this.loadList();
        },
        selectStarred: function () {
            this.restoringRoute = false;
            if (this.starred)
                return;
            this.starred = true;
            this.locationId = '';
            this.classId = '';
            this.resetList();
            this.clearDetail();
            this.loadList();
        },
        changeFilter: function (filter) {
            this.restoringRoute = false;
            if (this.readFilter === filter)
                return;
            this.readFilter = filter;
            this.resetList();
            this.clearDetail();
            this.loadList();
        },
        loadList: function () {
            return __awaiter(this, void 0, void 0, function () {
                var request, scopeKey, confirmedReads, targetCount, requestSize, pageCount, fetched, total, pageNumber, page, seen_1, selected_1, error_3;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if ((!this.starred && !this.locationId) || !this.canAccess || this.destroyed)
                                return [2 /*return*/];
                            request = ++this.listRequest;
                            this.listLoading = true;
                            this.loadingMore = false;
                            this.listError = '';
                            this.loadMoreError = '';
                            scopeKey = this.listScopeKey;
                            confirmedReads = Object.entries(this.optimisticReads).filter(function (_a) {
                                var state = _a[1];
                                return state.confirmed;
                            });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            targetCount = this.current * this.size;
                            requestSize = Math.min(100, targetCount);
                            pageCount = Math.ceil(targetCount / requestSize);
                            fetched = [];
                            total = 0;
                            pageNumber = 1;
                            _a.label = 2;
                        case 2:
                            if (!(pageNumber <= pageCount)) return [3 /*break*/, 5];
                            return [4 /*yield*/, getConversations(this.listQuery(pageNumber, requestSize))];
                        case 3:
                            page = _a.sent();
                            if (this.destroyed || request !== this.listRequest)
                                return [2 /*return*/];
                            total = Number(page.total) || 0;
                            fetched.push.apply(fetched, page.records);
                            if (fetched.length >= total || page.records.length < requestSize)
                                return [3 /*break*/, 5];
                            _a.label = 4;
                        case 4:
                            pageNumber++;
                            return [3 /*break*/, 2];
                        case 5:
                            if (this.destroyed || request !== this.listRequest)
                                return [2 /*return*/];
                            seen_1 = new Set();
                            this.records = fetched.slice(0, targetCount).filter(function (record) {
                                var id = String(record.id);
                                if (seen_1.has(id))
                                    return false;
                                seen_1.add(id);
                                return true;
                            });
                            this.total = total;
                            this.current = Math.max(1, Math.min(this.current, Math.ceil(total / this.size)));
                            selected_1 = this.records.find(function (record) { return String(record.id) === _this.selectedId; });
                            if (selected_1)
                                this.selectedRecord = __assign(__assign({}, (this.selectedRecord || {})), selected_1);
                            confirmedReads.forEach(function (_a) {
                                var id = _a[0], state = _a[1];
                                if (_this.optimisticReads[id] === state &&
                                    state.scopeKey === scopeKey &&
                                    (id !== _this.selectedId || selected_1))
                                    _this.$delete(_this.optimisticReads, id);
                            });
                            // A refresh can move the open conversation outside the loaded rows.
                            // Keep its message panel (and draft) until the user chooses another row.
                            if (!this.selectedId && this.records.length)
                                this.selectConversation(this.records[0]);
                            return [3 /*break*/, 8];
                        case 6:
                            error_3 = _a.sent();
                            if (!this.destroyed && request === this.listRequest)
                                this.listError = this.errorMessage(error_3);
                            return [3 /*break*/, 8];
                        case 7:
                            if (!this.destroyed && request === this.listRequest)
                                this.listLoading = false;
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        loadMore: function () {
            return __awaiter(this, void 0, void 0, function () {
                var request, nextPage, page, seen_2, appended, error_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if ((!this.starred && !this.locationId) ||
                                !this.canAccess ||
                                this.destroyed ||
                                this.listLoading ||
                                this.loadingMore ||
                                this.listError ||
                                this.refreshing ||
                                this.mutating ||
                                !this.hasMore)
                                return [2 /*return*/];
                            request = ++this.listRequest;
                            nextPage = this.current + 1;
                            this.loadingMore = true;
                            this.loadMoreError = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getConversations(this.listQuery(nextPage, this.size))];
                        case 2:
                            page = _a.sent();
                            if (this.destroyed || request !== this.listRequest)
                                return [2 /*return*/];
                            seen_2 = new Set(this.records.map(function (record) { return String(record.id); }));
                            appended = page.records.filter(function (record) {
                                var id = String(record.id);
                                if (seen_2.has(id))
                                    return false;
                                seen_2.add(id);
                                return true;
                            });
                            this.records = __spreadArray(__spreadArray([], this.records, true), appended, true);
                            this.total = Number(page.total) || 0;
                            this.current = nextPage;
                            return [3 /*break*/, 5];
                        case 3:
                            error_4 = _a.sent();
                            if (!this.destroyed && request === this.listRequest)
                                this.loadMoreError = this.errorMessage(error_4);
                            return [3 /*break*/, 5];
                        case 4:
                            if (!this.destroyed && request === this.listRequest)
                                this.loadingMore = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        selectConversation: function (record) {
            this.restoringRoute = false;
            var id = String(record.id);
            if (this.selectedId === id) {
                if (this.detailLoading || this.readBusy[id])
                    return;
                var current = this.records.find(function (item) { return String(item.id) === id; }) || this.selectedRecord || record;
                if (isUnread(current) || !this.detail) {
                    this.beginOptimisticRead(current);
                    this.loadDetail();
                }
                else {
                    this.markRead(this.detail);
                }
                return;
            }
            this.clearDetail(false);
            var index = this.visibleRecords.findIndex(function (item) { return String(item.id) === id; });
            this.selectedId = id;
            this.selectedRecord = __assign({}, record);
            this.selectedRecordIndex = Math.max(0, index);
            this.beginOptimisticRead(record);
            this.setRouteConversation(id, this.classId || String(record.classId || ''));
            this.loadDetail();
        },
        loadDetail: function () {
            return __awaiter(this, arguments, void 0, function (background) {
                var id, request, listVersion, pendingRead, confirmedRead, openedDetail, detail_1, error_5, failure, status_1;
                var _this = this;
                if (background === void 0) { background = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.selectedId || !this.canAccess || this.destroyed)
                                return [2 /*return*/];
                            id = this.selectedId;
                            request = ++this.detailRequest;
                            listVersion = this.listRequest;
                            pendingRead = this.optimisticReads[id];
                            confirmedRead = pendingRead && pendingRead.confirmed ? pendingRead : null;
                            if (!background)
                                this.detailLoading = true;
                            this.detailError = '';
                            openedDetail = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getConversation(id)];
                        case 2:
                            detail_1 = _a.sent();
                            if (this.destroyed || request !== this.detailRequest || id !== this.selectedId)
                                return [2 /*return*/];
                            this.detail = detail_1;
                            this.selectedRecord = __assign(__assign({}, (this.selectedRecord || {})), detail_1);
                            if (listVersion === this.listRequest && [0, 1, '0', '1'].includes(detail_1.isRead)) {
                                this.records.forEach(function (record) {
                                    if (String(record.id) === id)
                                        _this.$set(record, 'isRead', detail_1.isRead);
                                });
                            }
                            if (confirmedRead && this.optimisticReads[id] === confirmedRead)
                                this.$delete(this.optimisticReads, id);
                            if (!background)
                                openedDetail = detail_1;
                            return [3 /*break*/, 5];
                        case 3:
                            error_5 = _a.sent();
                            if (!this.destroyed && request === this.detailRequest && id === this.selectedId) {
                                failure = (error_5 || {});
                                status_1 = Number(failure.response && failure.response.status) || Number(failure.code);
                                if (!background || [401, 403, 404].includes(status_1) || !Auth.getToken()) {
                                    this.detail = null;
                                }
                                if (!background)
                                    this.rollbackOptimisticRead(id);
                                if ([401, 403, 404].includes(status_1) || !Auth.getToken())
                                    this.selectedRecord = null;
                                this.detailError = this.errorMessage(error_5);
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            if (!this.destroyed && request === this.detailRequest)
                                this.detailLoading = false;
                            return [7 /*endfinally*/];
                        case 5:
                            if (!(openedDetail && this.detail === openedDetail && id === this.selectedId)) return [3 /*break*/, 8];
                            return [4 /*yield*/, this.$nextTick()];
                        case 6:
                            _a.sent();
                            if (!(!this.destroyed && this.detail === openedDetail && id === this.selectedId)) return [3 /*break*/, 8];
                            return [4 /*yield*/, this.markRead(openedDetail)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        synchronizeState: function () {
            return __awaiter(this, void 0, void 0, function () {
                var changed;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.destroyed)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.loadLocations(true)];
                        case 1:
                            changed = _a.sent();
                            if (!(!changed && !this.destroyed)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.loadList()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        onReplySent: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.destroyed)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.synchronizeState()];
                        case 1:
                            _a.sent();
                            if (!(!this.destroyed && this.selectedId === id)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.loadDetail(true)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        onMessageMutated: function (change) {
            return __awaiter(this, void 0, void 0, function () {
                var id;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.destroyed)
                                return [2 /*return*/];
                            if (!(change.kind === 'topic' && change.action === 'delete')) return [3 /*break*/, 2];
                            this.clearDetail();
                            return [4 /*yield*/, this.synchronizeState()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            id = this.selectedId;
                            return [4 /*yield*/, this.synchronizeState()];
                        case 3:
                            _a.sent();
                            if (!(!this.destroyed && this.selectedId === id)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.loadDetail(true)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        onCreated: function (created) {
            return __awaiter(this, void 0, void 0, function () {
                var first, record;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.createOpen = false;
                            if (this.destroyed || !created.length)
                                return [2 /*return*/];
                            first = created[0];
                            this.starred = false;
                            this.locationId = first.locationId;
                            this.classId = '';
                            this.readFilter = 'ALL';
                            this.resetList();
                            this.clearDetail();
                            return [4 /*yield*/, this.loadLocations(true)];
                        case 1:
                            _a.sent();
                            if (this.destroyed || this.locationsError)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.loadList()];
                        case 2:
                            _a.sent();
                            if (this.destroyed)
                                return [2 /*return*/];
                            record = this.records.find(function (item) { return String(item.id) === first.conversationId; });
                            if (record)
                                this.selectConversation(record);
                            return [2 /*return*/];
                    }
                });
            });
        },
        markRead: function (conversation) {
            return __awaiter(this, void 0, void 0, function () {
                var id, snapshot, optimistic, error_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!conversation || this.destroyed || !this.canAccess)
                                return [2 /*return*/];
                            id = String(conversation.id);
                            snapshot = conversation.readSnapshot;
                            if (this.readBusy[id])
                                return [2 /*return*/];
                            optimistic = this.beginOptimisticRead(conversation);
                            if (!Array.isArray(snapshot) || !snapshot.length) {
                                if (optimistic && this.optimisticReads[id] === optimistic)
                                    this.$delete(this.optimisticReads, id);
                                return [2 /*return*/];
                            }
                            this.$set(this.readBusy, id, true);
                            this.actionError = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            return [4 /*yield*/, markConversationRead(id, snapshot)];
                        case 2:
                            _a.sent();
                            if (this.destroyed)
                                return [2 /*return*/];
                            if (optimistic && this.optimisticReads[id] === optimistic)
                                optimistic.confirmed = true;
                            if (this.failedReadId === id)
                                this.failedReadId = '';
                            return [4 /*yield*/, this.synchronizeState()];
                        case 3:
                            _a.sent();
                            if (!(this.selectedId === id && !this.detailLoading)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.loadDetail(true)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            error_6 = _a.sent();
                            if (!this.destroyed) {
                                this.rollbackOptimisticRead(id, optimistic);
                                this.failedReadId = id;
                                this.actionError = "Unable to mark this conversation as read. ".concat(this.errorMessage(error_6));
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            if (!this.destroyed) {
                                if (optimistic && this.optimisticReads[id] === optimistic)
                                    this.$delete(this.optimisticReads, id);
                                this.$delete(this.readBusy, id);
                            }
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        presentConversation: function (record) {
            var state = this.optimisticReads[String(record.id)];
            return state ? __assign(__assign({}, record), { isRead: state.confirmed ? 1 : state.record.isRead }) : record;
        },
        beginOptimisticRead: function (record) {
            var id = String(record.id);
            if (this.optimisticReads[id])
                return this.optimisticReads[id];
            if (!isUnread(record) || this.readBusy[id])
                return;
            var index = this.records.findIndex(function (item) { return String(item.id) === id; });
            var state = {
                record: __assign(__assign({}, (index >= 0 ? this.records[index] : {})), record),
                index: Math.max(0, index),
                scopeKey: this.listScopeKey,
                confirmed: false
            };
            this.$set(this.optimisticReads, id, state);
            return state;
        },
        rollbackOptimisticRead: function (id, expected) {
            var state = this.optimisticReads[id];
            if (!state || state.confirmed || (expected && expected !== state))
                return;
            this.$delete(this.optimisticReads, id);
            if (state.scopeKey !== this.listScopeKey)
                return;
            var existing = this.records.find(function (record) { return String(record.id) === id; });
            if (existing) {
                this.$set(existing, 'isRead', state.record.isRead);
            }
            else {
                var records = __spreadArray([], this.records, true);
                records.splice(Math.min(state.index, records.length), 0, state.record);
                this.records = records;
            }
            if (this.selectedRecord && String(this.selectedRecord.id) === id)
                this.$set(this.selectedRecord, 'isRead', state.record.isRead);
        },
        setStarredState: function (id, starred) {
            var _this = this;
            this.records.forEach(function (record) {
                if (String(record.id) === id)
                    _this.$set(record, 'starred', starred);
            });
            if (this.detail && String(this.detail.id) === id)
                this.$set(this.detail, 'starred', starred);
            if (this.selectedRecord && String(this.selectedRecord.id) === id)
                this.$set(this.selectedRecord, 'starred', starred);
        },
        toggleStar: function (conversation) {
            return __awaiter(this, void 0, void 0, function () {
                var id, previous, result, error_7;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            id = String(conversation.id);
                            if (this.destroyed || !this.canAccess || this.starBusy[id] || this.bulkReading)
                                return [2 /*return*/];
                            previous = !!conversation.starred;
                            this.$set(this.starBusy, id, true);
                            this.setStarredState(id, !previous);
                            this.actionError = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, 5, 6]);
                            return [4 /*yield*/, setConversationStar(id, !previous)];
                        case 2:
                            result = _a.sent();
                            if (this.destroyed)
                                return [2 /*return*/];
                            this.setStarredState(id, !!result.starred);
                            return [4 /*yield*/, this.synchronizeState()];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 6];
                        case 4:
                            error_7 = _a.sent();
                            if (!this.destroyed) {
                                this.setStarredState(id, previous);
                                this.actionError = "Unable to update the star. ".concat(this.errorMessage(error_7));
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            if (!this.destroyed)
                                this.$delete(this.starBusy, id);
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
        markAllRead: function () {
            return __awaiter(this, void 0, void 0, function () {
                var filter, error_8;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.destroyed ||
                                !this.canAccess ||
                                this.mutating ||
                                this.listLoading ||
                                !this.total ||
                                this.readFilter !== 'UNREAD')
                                return [2 /*return*/];
                            filter = __assign(__assign(__assign({}, (this.locationId ? { locationId: this.locationId } : {})), (this.classId ? { classId: this.classId } : {})), { starred: this.starred, readFilter: 'UNREAD' });
                            this.bulkReading = true;
                            this.actionError = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            return [4 /*yield*/, markAllConversationsRead(filter)];
                        case 2:
                            _a.sent();
                            if (this.destroyed)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.synchronizeState()];
                        case 3:
                            _a.sent();
                            if (!(this.selectedId && !this.detailLoading)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.loadDetail(true)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            error_8 = _a.sent();
                            if (!this.destroyed)
                                this.actionError = "Unable to mark all as read. ".concat(this.errorMessage(error_8));
                            return [3 /*break*/, 8];
                        case 7:
                            if (!this.destroyed)
                                this.bulkReading = false;
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        onVisibilityChange: function () {
            if (document.hidden)
                return;
            this.requestRefresh('visible');
        },
        requestRefresh: function (trigger) {
            if (this.destroyed || !this.canAccess)
                return;
            var catchUp = trigger === 'changed' || trigger === 'connected';
            if (!this.initialLoadStarted) {
                if (catchUp)
                    this.refreshPending = true;
                return;
            }
            // Routine triggers are covered by an active load; real changes must be retained.
            if (!catchUp && (document.hidden || this.refreshBlocked)) {
                if (this.refreshPending)
                    this.scheduleRefresh();
                return;
            }
            this.refreshPending = true;
            this.scheduleRefresh();
        },
        scheduleRefresh: function () {
            var _this = this;
            if (this.destroyed ||
                !this.canAccess ||
                document.hidden ||
                !this.refreshPending ||
                this.refreshTimer !== null)
                return;
            this.refreshTimer = window.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.refreshTimer = null;
                            if (this.destroyed || document.hidden || !this.refreshPending)
                                return [2 /*return*/];
                            if (this.refreshBlocked) {
                                this.scheduleRefresh();
                                return [2 /*return*/];
                            }
                            this.refreshPending = false;
                            return [4 /*yield*/, this.refresh()];
                        case 1:
                            _a.sent();
                            if (this.refreshPending)
                                this.scheduleRefresh();
                            return [2 /*return*/];
                    }
                });
            }); }, 300);
        },
        refresh: function () {
            return __awaiter(this, void 0, void 0, function () {
                var scopeChanged;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (document.hidden ||
                                this.destroyed ||
                                !this.canAccess ||
                                !this.initialLoadStarted ||
                                this.refreshBlocked)
                                return [2 /*return*/];
                            this.refreshing = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            return [4 /*yield*/, this.loadLocations(true)];
                        case 2:
                            scopeChanged = _a.sent();
                            if (!(!scopeChanged && !this.locationsError)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.loadList()];
                        case 3:
                            _a.sent();
                            if (!(!this.detailLoading && !this.listError)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.loadDetail(true)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            this.refreshing = false;
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
    }
});
